module.exports = __webpack_public_path__ + "static/logo-java-8792a4a9971a4f9b832c6ad084509c79.png";